import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PresupuestosEstadosComponent } from './components/presupuestos-estados/presupuestos-estados.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { TableModule } from 'primeng/table';
import { PresupuestosAcumuladosComponent } from './components/presupuestos-acumulados/presupuestos-acumulados.component';
import { CargaPresupuestosComponent } from './components/carga-presupuestos/carga-presupuestos.component';
import { ReportePresupuestosEstadosComponent } from './components/reporte-presupuestos-estados/reporte-presupuestos-estados.component';
import { SeleccionReportesComponent } from './components/seleccion-reportes/seleccion-reportes.component';
import { AppRoutingModule } from 'src/app/core/app-routing.module';
import { FormatoPdfPresupuestosEstadoComponent } from './components/formato-pdf-presupuestos-estado/formato-pdf-presupuestos-estado.component';
import { ModalPresupuestosEstadosComponent } from './components/modal-presupuestos-estados/modal-presupuestos-estados.component';
import { GraficaAvanceFinancieroComponent } from './components/grafica-avance-financiero/grafica-avance-financiero.component';
import { ChartModule } from 'primeng/chart';
import { ToastModule } from 'primeng/toast';
import { GraficaBarrasPrepEstadosComponent } from './components/grafica-barras-prep-estados/grafica-barras-prep-estados.component';
import { DetallePresupuestoEstadoComponent } from './components/detalle-presupuesto-estado/detalle-presupuesto-estado.component';
import { ModalGraficaAvanceFinancieroComponent } from './components/modal-grafica-avance-financiero/modal-grafica-avance-financiero.component';
import { ModalSeguimientoPefComponent } from './components/modal-seguimiento-pef/modal-seguimiento-pef.component';
import { SeguimientoPefComponent } from './components/seguimiento-pef/seguimiento-pef.component';
import { GraficaMapaComponent } from './components/grafica-mapa/grafica-mapa.component';
import { HomePresupuestosComponent } from './components/home-presupuestos/home-presupuestos.component';
import { ChartModule as HighChartModule, HIGHCHARTS_MODULES } from 'angular-highcharts';
import * as highmaps from 'highcharts/modules/map.src';
import { HttpClientModule } from '@angular/common/http';
import { IndicadoresComponent } from './components/indicadores/indicadores.component';
import { PresupuestosProgramasComponent } from './components/presupuestos-programas/presupuestos-programas.component';
import { GraficaCorredoresComponent } from './components/grafica-corredores/grafica-corredores.component';
import { GraficaPieComponent } from './components/grafica-pie/grafica-pie.component';
import { ModalPresupuestosProgramasComponent } from './components/modal-presupuestos-programas/modal-presupuestos-programas.component';
import { ModalDetallePresupuestoEstadoComponent } from './components/modal-detalle-presupuesto-estado/modal-detalle-presupuesto-estado.component';
import { TooltipModule } from 'primeng/tooltip';
import { ObrasModule } from '../obras/obras.module';
import { CalendarioPefComponent } from './components/calendario-pef/calendario-pef.component';
import { CheckboxModule } from 'primeng/checkbox';

import {SidebarModule} from 'primeng/sidebar';

@NgModule({
  declarations: [
    CargaPresupuestosComponent,
    PresupuestosEstadosComponent,
    PresupuestosAcumuladosComponent,
    SeleccionReportesComponent,
    ReportePresupuestosEstadosComponent,
    ModalPresupuestosEstadosComponent,
    FormatoPdfPresupuestosEstadoComponent,
    GraficaAvanceFinancieroComponent,
    ModalGraficaAvanceFinancieroComponent,
    ModalSeguimientoPefComponent,
    SeguimientoPefComponent,
    GraficaBarrasPrepEstadosComponent,
    DetallePresupuestoEstadoComponent,
    ModalGraficaAvanceFinancieroComponent,
    GraficaMapaComponent,
    HomePresupuestosComponent,
    IndicadoresComponent,
    PresupuestosProgramasComponent,
    GraficaCorredoresComponent,
    GraficaPieComponent,
    ModalPresupuestosProgramasComponent,
    ModalDetallePresupuestoEstadoComponent,
    CalendarioPefComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    CalendarModule,
    TableModule,
    ChartModule,
    ToastModule,
    AppRoutingModule,
    HighChartModule,
    HttpClientModule,
    TooltipModule,
    ObrasModule,
    CheckboxModule,
    SidebarModule
  ],
  exports: [
    PresupuestosEstadosComponent,
    PresupuestosAcumuladosComponent,
    CargaPresupuestosComponent,
    SeleccionReportesComponent,
    ReportePresupuestosEstadosComponent
  ],
  providers: [
    { provide: HIGHCHARTS_MODULES, useFactory: () => [highmaps] }
  ]
})
export class PresupuestosModule { }
